import React, { useRef } from 'react';
import { ImageFile } from '../../types';
import './FileSelector.css';

interface FileSelectorProps {
  availableImages: ImageFile[];
  currentImageFile: ImageFile | null;
  onDirectoryLoad: (files: FileList) => void;
  onImageSelect: (imageFile: ImageFile) => void;
}

export const FileSelector: React.FC<FileSelectorProps> = ({
  availableImages,
  currentImageFile,
  onDirectoryLoad,
  onImageSelect
}) => {
  const directoryInputRef = useRef<HTMLInputElement>(null);

  const handleDirectoryClick = () => {
    directoryInputRef.current?.click();
  };

  const handleDirectoryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      onDirectoryLoad(files);
    }
  };

  return (
    <div className="file-selector">
      <div className="directory-upload" onClick={handleDirectoryClick}>
        <input
          ref={directoryInputRef}
          type="file"
          multiple
          {...({ webkitdirectory: "" } as any)}
          style={{ display: 'none' }}
          onChange={handleDirectoryChange}
        />
        <div className="upload-content">
          <div className="upload-icon">📁</div>
          <h3>選擇資料夾</h3>
          <p>點擊選擇包含影像和CSV檔案的資料夾</p>
          <small>系統會自動匹配對應的CSV檔案</small>
        </div>
      </div>

      {availableImages.length > 0 && (
        <div className="image-list">
          <h4>可用影像檔案 ({availableImages.length})</h4>
          <div className="image-grid">
            {availableImages.map((imageFile, index) => (
              <div
                key={index}
                className={`image-item ${currentImageFile?.name === imageFile.name ? 'selected' : ''}`}
                onClick={() => onImageSelect(imageFile)}
              >
                <div className="image-info">
                  <span className="image-name">{imageFile.name}</span>
                  <span className={`csv-status ${imageFile.csvPath ? 'has-csv' : 'no-csv'}`}>
                    {imageFile.csvPath ? '✓ 有CSV' : '✗ 無CSV'}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};